export const ADMIN_FETCH_POLICIES = Symbol('ADMIN_FETCH_POLICIES');
export const ADMIN_UPDATE_POLICIES = Symbol('ADMIN_UPDATE_POLICIES');
export const ADMIN_SET_POLICIES = Symbol('ADMIN_SET_POLICIES');
export const ADMIN_SET_CHANNELS = Symbol('ADMIN_SET_CHANNELS');
export const ADMIN_IS_LOADING = Symbol('ADMIN_IS_LOADING');

/**
 * @param {number} websiteId
 * @return {{type: symbol, payload: {websiteId: number}}}
 */
export const adminFetchPoliciesRequestAction = (websiteId) => ({ type: ADMIN_FETCH_POLICIES, payload: { websiteId } });

/**
 * @param {policyModel[]} policies
 * @returns {{type: symbol, payload: {policies: policyModel[]}}}
 */
export const adminSetPoliciesAction = (policies) => ({ type: ADMIN_SET_POLICIES, payload: { policies } });

/**
 * @param {channelModel[]} channels
 * @returns {{type: symbol, payload: {channels: channelModel[]}}}
 */
export const adminSetChannelsAction = (channels) => ({ type: ADMIN_SET_CHANNELS, payload: { channels } });

/**
 * @param {policyModel[]} policies
 * @param {number} websiteId
 * @return {{type: symbol, payload: {policies: *, websiteId: *}}}
 */
export const adminUpdatePoliciesRequestAction = (policies, websiteId) => ({
  type: ADMIN_UPDATE_POLICIES,
  payload: { policies, websiteId },
});

/**
 * @param {boolean} isLoading
 * @return {{type: symbol, payload: {isLoading: boolean}}}
 */
export const adminIsLoadingAction = (isLoading) => ({
  type: ADMIN_IS_LOADING,
  payload: { isLoading },
});
